export enum TaskInputType {
  Manual = 'Manual',
  Automatic = 'Automatic',
  Event = 'Event',
}
